<script setup lang="ts">
import { computed } from 'vue';

interface ErrorMessageProps {
  message?: string | string[];
  type?: 'error' | 'warning' | 'info';
}

const props = withDefaults(defineProps<ErrorMessageProps>(), {
  type: 'error',
  message: ''
});

// Convert message to array for consistent handling
const errorMessages = computed(() => {
  if (!props.message) return [];
  if (Array.isArray(props.message)) return props.message;
  return [props.message];
});

// Simple color classes based on type
const textColor = computed(() => {
  switch (props.type) {
    case 'error': return 'text-red-600';
    case 'warning': return 'text-yellow-600';
    case 'info': return 'text-blue-600';
    default: return 'text-red-600';
  }
});
</script>

<template>
  <div
    v-if="errorMessages.length > 0"
    :class="[textColor]"
    role="alert"
  >
    <span
      v-for="(msg, index) in errorMessages"
      :key="index"
      class="text-sm"
    >
      {{ msg }}
    </span>
  </div>
</template>